import { z } from "zod";
/**
 * Enum values are stored as plain strings in Postgres rather than native
 * enums — adding a service type later is then a code change, not a migration.
 */
export const SERVICE_TYPES = [
    "PERIODIC",
    "ACCESSORIES",
    "COMPLAINT",
    "WASH",
    "TYRE",
    "INSURANCE",
    "OTHER",
];
export const serviceTypeSchema = z.enum(SERVICE_TYPES);
export const SERVICE_TYPE_LABELS = {
    PERIODIC: "Periodic service",
    ACCESSORIES: "Accessories",
    COMPLAINT: "Complaint / repair",
    WASH: "Wash & detailing",
    TYRE: "Tyres & wheels",
    INSURANCE: "Insurance & documents",
    OTHER: "Other",
};
export const SERVICE_ITEM_KINDS = [
    "PART",
    "CONSUMABLE",
    "LABOUR",
    "ACCESSORY",
    "OTHER",
];
export const serviceItemKindSchema = z.enum(SERVICE_ITEM_KINDS);
export const VEHICLE_TYPES = ["CAR", "BIKE", "SCOOTER", "COMMERCIAL"];
export const vehicleTypeSchema = z.enum(VEHICLE_TYPES);
export const VEHICLE_TYPE_LABELS = {
    CAR: "Car",
    BIKE: "Bike",
    SCOOTER: "Scooter",
    COMMERCIAL: "Commercial",
};
export const FUEL_TYPES = ["PETROL", "DIESEL", "CNG", "EV", "HYBRID"];
export const fuelTypeSchema = z.enum(FUEL_TYPES);
// Spelled out rather than title-cased at the call site, which turned CNG into
// "Cng" and EV into "Ev".
export const FUEL_LABELS = {
    PETROL: "Petrol",
    DIESEL: "Diesel",
    CNG: "CNG",
    EV: "Electric",
    HYBRID: "Hybrid",
};
export const ATTACHMENT_KINDS = ["INVOICE", "PHOTO", "WARRANTY", "OTHER"];
export const attachmentKindSchema = z.enum(ATTACHMENT_KINDS);
//# sourceMappingURL=enums.js.map